import { InjectionToken, Signal, inject } from '@angular/core';
import { User as FirebaseUser } from '@angular/fire/auth';
import { Observable } from 'rxjs';
import { AuthClientService } from '../services/auth-client.service';

export const AUTH_CLIENT_TOKEN: InjectionToken<AuthClientProvider> = new InjectionToken<AuthClientProvider>(
  'AUTH_CLIENT_TOKEN',
  {
    providedIn: 'root',
    factory: (): AuthClientProvider => {
      const service: AuthClientService = inject(AuthClientService);
      return {
        get isAuthed$(): Observable<boolean> {
          return service.isAuthed$;
        },
        get currentUser$(): Observable<FirebaseUser | null> {
          return service.currentUser$;
        },
        get currentUser(): Signal<FirebaseUser | null> {
          return service.currentUser;
        },
        getIdToken(forceRefresh?: boolean): Promise<string | null> {
          return service.getIdToken(forceRefresh);
        },
        signOut(): Promise<void> {
          return service.signOut();
        }
      };
    }
  }
);

export interface AuthClientProvider {
  readonly isAuthed$: Observable<boolean>;
  readonly currentUser$: Observable<FirebaseUser | null>;
  readonly currentUser: Signal<FirebaseUser | null>;
  getIdToken(forceRefresh?: boolean): Promise<string | null>;
  signOut(): Promise<void>;
}
